import { gql } from 'graphql-request';

export const LIVE_MATCH = gql`
  query ($tournamentSeasonId: ID!) {
    resolveEvent(id: $tournamentSeasonId) {
      assetId
      assetType
    }
  }
`;
